import React from 'react';
import cx from 'classnames';
import {LayoutContext} from '../ProductPageApp/ProductPageApp';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import s from './ProductName.scss';
import {classes as productNameStyles} from './ProductName.st.css';
import {ProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';
import {HeadingTags} from '@wix/wixstores-client-core/dist/es/src/types/heading-tags';

export interface ProductNameProps extends ProvidedGlobalProps {
  name: string;
}

export const ProductNameDataHook = 'product-title';

class ProductNameComp extends React.Component<ProductNameProps> {
  private renderProductNameWithoutHtmlTag(layoutName: string): JSX.Element {
    return (
      <h1 data-hook={ProductNameDataHook} className={cx(s.productName, s[`productName__${layoutName}`])}>
        {this.props.name}
      </h1>
    );
  }

  private renderProductNameWithHtmlTag(layoutName: string, titleHtmlTag: HeadingTags): JSX.Element {
    return (
      <Text
        tagName={titleHtmlTag}
        data-hook={ProductNameDataHook}
        className={cx(
          s.productNameWithHtmlTag,
          s[`productNameWithHtmlTag__${layoutName}`],
          productNameStyles.root,
          productNameStyles[layoutName]
        )}>
        {this.props.name}
      </Text>
    );
  }

  public render(): JSX.Element {
    const {
      globals: {htmlTags, experiments, isQuickView},
    } = this.props;
    const shouldRenderHtmlTag = experiments.productNameHtmlTag && !isQuickView;

    return (
      <LayoutContext.Consumer>
        {(layoutName) =>
          shouldRenderHtmlTag
            ? this.renderProductNameWithHtmlTag(layoutName, htmlTags.titleHtmlTag)
            : this.renderProductNameWithoutHtmlTag(layoutName)
        }
      </LayoutContext.Consumer>
    );
  }
}

export const ProductName = withGlobalProps(ProductNameComp);
